import { api } from "../lib";
import type { DateOnlyString } from "../utils/dateOnly";

export interface AssignPathologistParams {
  sendingPracticeId?: string;
  physicianId?: string;
  surgeryCenterLabId?: string;
  date?: DateOnlyString;
}

export interface PathologistAssignmentResult {
  pathologistId: string;
  reason: string;
}

/**
 * Auto-assign a pathologist based on 5-tier priority logic:
 * 1. Physician's preferred pathologist
 * 2. Surgery center/lab's preferred pathologist
 * 3. Practice's preferred pathologist
 * 4. Load-balanced pathologist (based on daily case counts)
 * 5. Fallback pathologist
 */
export async function assignPathologist(
  params: AssignPathologistParams
): Promise<PathologistAssignmentResult> {
  // Note: api.post already extracts .data from the response
  return api.post<PathologistAssignmentResult>("/cases/assign-pathologist", {
    sendingPracticeId: params.sendingPracticeId,
    physicianId: params.physicianId,
    surgeryCenterLabId: params.surgeryCenterLabId,
    date: params.date,
  });
}
